
type MonthlyCounter = {
  count: number;
  lastResetMonth: number;
  lastResetYear: number;
};

const INITIAL_COUNT = 20;
const CURRENT_COUNT = 56; // Current display value

// Initialize or retrieve the counter from localStorage
export const getFamilyCounter = (): MonthlyCounter => {
  // Check if we have stored data
  const storedData = localStorage.getItem('familyCounter');
  
  if (storedData) {
    const parsedData: MonthlyCounter = JSON.parse(storedData);
    
    // Get current date to check if we need to reset
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    
    // Reset counter if we're in a new month
    if (currentMonth !== parsedData.lastResetMonth || 
        currentYear !== parsedData.lastResetYear) {
      
      const newCounter: MonthlyCounter = {
        count: INITIAL_COUNT,
        lastResetMonth: currentMonth,
        lastResetYear: currentYear
      };
      
      localStorage.setItem('familyCounter', JSON.stringify(newCounter));
      return newCounter;
    }
    
    return parsedData;
  } else {
    // First time initialization
    const now = new Date();
    const newCounter: MonthlyCounter = {
      count: CURRENT_COUNT, // Start with our current count
      lastResetMonth: now.getMonth(),
      lastResetYear: now.getFullYear()
    };
    
    localStorage.setItem('familyCounter', JSON.stringify(newCounter));
    return newCounter;
  }
};

// Increment the counter by a given amount (default 1)
export const incrementFamilyCounter = (amount = 1): number => {
  const currentCounter = getFamilyCounter();
  
  const updatedCounter: MonthlyCounter = {
    ...currentCounter,
    count: currentCounter.count + amount
  };
  
  localStorage.setItem('familyCounter', JSON.stringify(updatedCounter));
  return updatedCounter.count;
};
